import i18n from '@/i18n';

const $t = (text) => {
  return i18n.global.t(text);
};

export const eventFiltering = [
  {
    value: 'productNames',
    id: 'productName',
    text: $t('page.eventFilter.monitoringTarget'),
    width: 310,
    minWidth: 100,
    sortable: true,
    bodyAlign: 'left',
    defaultValue: '',
    isVisible: true
  },
  {
    text: $t('page.eventFilter.eventFiltering'),
    value: 'eventFilteringName',
    id: 'eventFilteringName',
    sortable: true,
    bodyAlign: 'left',
    isVisible: true
  },

  {
    value: 'repetitionType',
    id: 'repetitionType',
    text: $t('page.eventFilter.repetitionType'),
    bodyAlign: 'left',
    defaultValue: '',
    width: 200,
    sortable: false
  },
  {
    value: 'period',
    id: 'period',
    text: $t('page.eventFilter.period'),
    sortable: true,
    bodyAlign: 'center',
    defaultValue: '',
    width: 220
  },
  {
    value: 'timePeriod',
    id: 'timePeriod',
    text: $t('page.eventFilter.timePeriod'),
    bodyAlign: 'center',
    defaultValue: '',
    width: 160
  },
  {
    value: 'activeYn',
    id: 'activeYn',
    text: $t('page.eventFilter.active'),
    width: 140,
    isNotResize: true,
    sortable: false,
    bodyAlign: 'center',
    defaultValue: ''
  }
];
